module.exports = __webpack_public_path__ + "img/zerstreulino.da55b232.png";